webpackJsonp([38899454822814],{

/***/ 2541:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/update-tweet-dialog.d268c092.png";

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PatternConstruction = __webpack_require__(22);
	
	var _PatternConstruction2 = _interopRequireDefault(_PatternConstruction);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _FormsPatternTutorialBranch = __webpack_require__(41);
	
	var _FormsPatternTutorialBranch2 = _interopRequireDefault(_FormsPatternTutorialBranch);
	
	var _updateTweetDialog = __webpack_require__(2541);
	
	var _updateTweetDialog2 = _interopRequireDefault(_updateTweetDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _PatternConstruction2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '1. Refactor Update Dialog'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'ll be refactoring the UpdateTweetDialog to leverage the blueprint we just created.'
	    ),
	    _react2.default.createElement(_FormsPatternTutorialBranch2.default, { branch: 'update.1' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Dialog Comparison'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you compared the original create dialog with the update dialog, very little is different. In fact, the only code that\'s different is reflected below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      ...\n      propTypes: {\n        tweet: PropTypes.object.isRequired\n      },\n\n      getInitialState() {\n        const { tweet } = this.props;\n\n        return {\n          data: {\n            text: tweet.data.text,\n            userId: tweet.data.userId\n          }\n        };\n      },\n\n      request(data) {\n        const { tweet } = this.props;\n        lore.actions.tweet.update(tweet, data);\n      },\n\n      render() {\n        ...\n        return (\n          <div className="modal-dialog">\n              ...\n                <h4 className="modal-title">\n                  Update Tweet\n                </h4>\n              ...\n              <div className="modal-footer">\n                ...\n                <button\n                  type="button"\n                  className="btn btn-primary"\n                  disabled={hasError}\n                  onClick={this.onSubmit}\n                >\n                  Update\n                </button>\n                ...\n              </div>\n              ...\n          </div>\n        );\n      }\n      ..\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this case, the update dialog is intended to ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'update a tweet'
	      ),
	      ', and so it requires a prop which is the tweet that should be updated.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'getInitialState()'
	      ),
	      ' method then uses that ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet'
	      ),
	      ' to set the initial state of the form, and when the form is submitted, the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'request()'
	      ),
	      ' method uses the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'update'
	      ),
	      ' action instead of the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'create'
	      ),
	      ' action.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Additionally, (looking at the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method) the title of the form is "Update Tweet" instead of "Create Tweet", and the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'onSubmit'
	      ),
	      ' button says "Update" instead of "Create".'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Other than that, the forms are identical.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Refactor Update Dialog'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lucky for us, it turns out that none of the differences captured above affect the blueprint, which means we can reuse it for the update dialog.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Open the update dialog located at ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'src/dialogs/tweet/update/index.js'
	      ),
	      ' and replace the contents with the code shown below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import React from \'react\';\n      import createReactClass from \'create-react-class\';\n      import PropTypes from \'prop-types\';\n      import OptimisticBlueprint from \'../../_blueprints/Optimistic\';\n\n      export default createReactClass({\n        displayName: \'UpdateTweetDialog\',\n\n        propTypes: {\n          onCancel: PropTypes.func,\n          tweet: PropTypes.object.isRequired\n        },\n\n        getInitialState() {\n          const { tweet } = this.props;\n\n          return {\n            data: {\n              text: tweet.data.text,\n              userId: tweet.data.userId\n            }\n          };\n        },\n\n        request(data) {\n          const { tweet } = this.props;\n          lore.actions.tweet.update(tweet, data);\n        },\n\n        render() {\n          const { data } = this.state;\n          const { schema, fieldMap, actionMap } = lore.config.dialogs;\n\n          return (\n            <OptimisticBlueprint\n              title="Update Tweet"\n              onCancel={this.props.onCancel}\n              data={data}\n              schema={schema}\n              fieldMap={fieldMap}\n              actionMap={actionMap}\n              request={this.request}\n              validators={function(data) {\n                return {\n                  text: [function(value) {\n                    if (!value) {\n                      return \'This field is required\';\n                    }\n                  }],\n                  userId: [function(value) {\n                    if (value === undefined) {\n                      return \'This field is required\'\n                    }\n                  }]\n                };\n              }}\n              fields={[\n                {\n                  key: \'text\',\n                  type: \'text\',\n                  props: {\n                    label: \'Message\',\n                    placeholder: "What\'s happening?"\n                  }\n                },\n                {\n                  key: \'userId\',\n                  type: \'select\',\n                  props: {\n                    label: \'User\',\n                    options: function(getState) {\n                      return getState(\'user.find\');\n                    },\n                    optionLabel: \'nickname\'\n                  }\n                }\n              ]}\n              actions={[\n                {\n                  key: \'cancel\',\n                  type: \'default\',\n                  props: (form) => {\n                    return {\n                      label: \'Cancel\',\n                      onClick: form.callbacks.dismiss\n                    };\n                  }\n                },\n                {\n                  key: \'submit\',\n                  type: \'primary\',\n                  props: (form) => {\n                    return {\n                      label: \'Update\',\n                      disabled: form.hasError,\n                      onClick: form.callbacks.onSubmit\n                    };\n                  }\n                }\n              ]}\n            />\n          );\n        }\n\n      });\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'While we won\'t do in this tutorial, if you compare the create and update dialogs at this point, you\'ll notice the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'validators'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'fields'
	      ),
	      ' are identical. And if you wanted, you could even move that part of the code into a location both dialogs could share, to further reduce code.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, clicking the edit link will still launch a dialog that you can use to edit an existing tweet.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _updateTweetDialog2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/dialogs/tweet/update/index.js'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import React from \'react\';\n      import createReactClass from \'create-react-class\';\n      import PropTypes from \'prop-types\';\n      import OptimisticBlueprint from \'../../_blueprints/Optimistic\';\n\n      export default createReactClass({\n        displayName: \'UpdateTweetDialog\',\n\n        propTypes: {\n          onCancel: PropTypes.func,\n          tweet: PropTypes.object.isRequired\n        },\n\n        getInitialState() {\n          const { tweet } = this.props;\n\n          return {\n            data: {\n              text: tweet.data.text,\n              userId: tweet.data.userId\n            }\n          };\n        },\n\n        request(data) {\n          const { tweet } = this.props;\n          lore.actions.tweet.update(tweet, data);\n        },\n\n        render() {\n          const { data } = this.state;\n          const { schema, fieldMap, actionMap } = lore.config.dialogs;\n\n          return (\n            <OptimisticBlueprint\n              title="Update Tweet"\n              onCancel={this.props.onCancel}\n              data={data}\n              schema={schema}\n              fieldMap={fieldMap}\n              actionMap={actionMap}\n              request={this.request}\n              validators={function(data) {\n                return {\n                  text: [function(value) {\n                    if (!value) {\n                      return \'This field is required\';\n                    }\n                  }],\n                  userId: [function(value) {\n                    if (value === undefined) {\n                      return \'This field is required\'\n                    }\n                  }]\n                };\n              }}\n              fields={[\n                {\n                  key: \'text\',\n                  type: \'text\',\n                  props: {\n                    label: \'Message\',\n                    placeholder: "What\'s happening?"\n                  }\n                },\n                {\n                  key: \'userId\',\n                  type: \'select\',\n                  props: {\n                    label: \'User\',\n                    options: function(getState) {\n                      return getState(\'user.find\');\n                    },\n                    optionLabel: \'nickname\'\n                  }\n                }\n              ]}\n              actions={[\n                {\n                  key: \'cancel\',\n                  type: \'default\',\n                  props: (form) => {\n                    return {\n                      label: \'Cancel\',\n                      onClick: form.callbacks.dismiss\n                    };\n                  }\n                },\n                {\n                  key: \'submit\',\n                  type: \'primary\',\n                  props: (form) => {\n                    return {\n                      label: \'Update\',\n                      disabled: form.hasError,\n                      onClick: form.callbacks.onSubmit\n                    };\n                  }\n                }\n              ]}\n            />\n          );\n        }\n\n      });\n      ' }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../../destroy/step-1/' },
	        'refactor the delete dialog'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-forms-pattern-update-step-1-js-87285c6e9b485832e8cc.js